import { actions as actions$1 } from '@grandvisionhq/state';

const updateActiveVariant = actions$1.action('UPDATE_ACTIVE_VARIANT', actions$1.payload());
const updatePurchaseType = actions$1.action('UPDATE_PURCHASE_TYPE', actions$1.payload());

export { updateActiveVariant, updatePurchaseType };
//# sourceMappingURL=actions.js.map
